module.exports = __webpack_public_path__ + "createstatic/media/closeBtn2.5fe62135.svg";